import { memo } from 'react';
import { AttributeAgreementTemplate } from 'components/templates/AttributeAgreementTemplate';

type Props = {};

export const AttributeAgreementPage = memo((_props: Props) => {
	return <AttributeAgreementTemplate />;
});
